import { render, staticRenderFns } from "./TimeCustomField.vue?vue&type=template&id=2c65f305&"
import script from "./TimeCustomField.vue?vue&type=script&lang=ts&"
export * from "./TimeCustomField.vue?vue&type=script&lang=ts&"
import style0 from "./TimeCustomField.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol})
